function invoiceRegeneratePdf(UserInfo) {
    return {
        restrict: 'AE',
        templateUrl: require('../../templates/regenerate-pdf-button.html'),
        controller: function ($scope, $http, $rootScope, $routeParams, Alert, $filter, $location) {
            var $translate = $filter('translate');

            var api = API_URL + '/api/1.0/invoices/' + $routeParams.id + '/regenerate-pdf/';

            $scope.flagConfirmRegenerate = false;

            $scope.canRegeneratePdfInvoice = function(){
                return UserInfo.hasPerm('invoices.add_invoice');
            }

            $scope.confirmRegenerate = function () {
                $scope.flagConfirmRegenerate = true;
            }

            $scope.clickNoRegenerate = function () {
                $scope.flagConfirmRegenerate = false;
            }

            $scope.clickYesRegenerate = function () {
                var config = {
                    method: "POST",
                    url: api,
                    headers: {"Content-Type": "application/json;charset=utf-8"}
                };
                $http(config)
                    .then(function (data, status, headers, config) {
                        Alert.createAlert('success', $translate('INVOICES.REGENERATE_PDF_SUCCESS'), true);
                        $location.path('/invoices/' + data.data.id);
                    }, function (data, status, headers, config) {
                        Alert.createAlert('danger', $translate('INVOICES.REGENERATE_PDF_ERROR'), true);
                    })
            }
        }
    }
}

export { invoiceRegeneratePdf }
